import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { OnboardingFinishResponse, SignupSummaryResponse } from '@shared/models';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService } from '@shared/services';
import { TranslateService } from '@ngx-translate/core';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OnboardingFinishApiService {
  constructor(
    private http: HttpClient,
    private router: Router,
    private toastService: ToastService,
    private translateService: TranslateService,
  ) {}

  //TODO: change this to signup summary url
  getSignupSummary(): Observable<SignupSummaryResponse> {
    return this.http.get<SignupSummaryResponse>(`/api/user/v2/auth/register/summary/`).pipe(
      catchError(() => {
        return of({ onboarding_parking_session: null } as SignupSummaryResponse);
      }),
    );
  }

  getOnboardingResponse(): Observable<OnboardingFinishResponse> {
    return this.http.get<OnboardingFinishResponse>(`/api/backoffice/v2/customer_portal/onboarding/`).pipe(
      catchError(() => {
        this.router.navigateByUrl('/dashboard');
        this.toastService.add({ type: 'error', message: this.translateService.instant('Common.Errors.PageCouldNotBeLoaded') });
        return of();
      }),
    );
  }
}
